import React, { Component } from 'react'
import Filter from '@/components/SendRecord/Filter'
import RecordExpandTable from '@/components/SendRecord/RecordExpandTable'
import styled from "styled-components"
import { Table, Spin, message } from 'antd'
import RecordAPI from '@/API/record'
import dayjs from 'dayjs'
import { withTranslation } from 'react-i18next'

const Container = styled.div`
  padding: 20px;
`;

const RecordTable=styled(Table)`
  margin-top:20px;
  .ant-table-expanded-row>td:nth-child(2){
    padding:0;
  }
`

const Danger = styled.div`
  color:#f81d22;
`;


class SendRecord extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading:false,
      pagination:{
        current:1,
        pageSize:10,
        total:0,
        showSizeChanger:true,
        size:'small',
        showTotal:(total)=>(this.props.t('Total items',{total:total}))
      },
      filter:{
        file:null,
        time:[],
        imei:null
      },
      recordList:[]
    };
  }
  filterChange=(key,value)=>{
    let field={}
    field[key]=value
    this.setState(prevState=>({
      filter:{
        ...prevState.filter,
        ...field
      }
    }))
  }
  download=() => {
    let {imei,time}=this.state.filter
    this.setState({loading:true})
    RecordAPI.getRecords({
      imei:imei,
      startTime:time[0]?dayjs(time[0]).format('YYYY-MM-DD'):null,
      endTime:time[1]?dayjs(time[1]).format('YYYY-MM-DD'):null,
      export: true
    }).then((res)=>{
      console.log(res)
      this.setState({loading: false})
    }).catch(() => {
      this.setState({loading: false})
    })
  }
  search=(clear)=>{
    const {filter}=this.state
    if(!filter.file&&!filter.imei){
      return message.warning(this.props.t('Enter IMEIs or import them.'))
    }
    if(clear){
      this.setState((prevState)=>({
        filter:{
          ...prevState.filter,
          file:null
        },
        pagination:{
          ...prevState.pagination,
          current:1
        }
      }),()=>{
        this.getData()
      })
    }else{
      this.setState((prevState)=>({
        pagination:{
          ...prevState.pagination,
          current:1
        }
      }),()=>{
        this.getData()
      })
    }
  }
  getData=()=>{
    this.setState({loading:true})
    const {pagination,filter}=this.state
    let formData=new FormData()
    const startTime=filter.time[0]?dayjs(filter.time[0]).startOf('day').unix():null
    const endTime=filter.time[1]?dayjs(filter.time[1]).endOf('day').unix():null
    filter.file&&formData.append('file',filter.file)
    filter.time[0]&&formData.append('startTime',startTime)
    filter.time[1]&&formData.append('endTime',endTime)
    filter.imei&&formData.append('imei',filter.imei)
    formData.append('pageIndex',pagination.current-1)
    formData.append('pageSize',pagination.pageSize)
    

    RecordAPI.getLastRecord(formData).then((res)=>{
      this.setState((prevState)=>({
        recordList:res.data||[],
        loading:false,
        pagination:{
          ...prevState.pagination,
          total:res.totalCount
        }
      }))
    }).catch(()=>{
      this.setState({loading:false})
    })
  }
  handleTableChange=(pagination)=>{
    this.setState({
      pagination: pagination,
    },()=>{
      this.getData()
    });
  }
  resend=(record)=>{
    RecordAPI.resendRecord({imei:record.imei}).then((res)=>{
      if(!res.code){
        this.setState((prevState)=>({
          recordList:prevState.recordList.map((record)=>({...record,status:res.code}))
        }))
        message.success(res.info)
      }else{
        message.error(res.info)
      }
    })
  }
  render() {
    const {filter,recordList,loading,pagination}=this.state
    const { t } = this.props;
    const columns=[
      {
        title:t('IMEI'),
        dataIndex:'imei',
        key:'imei',
        width:150,
        align:'center'
      },
      {
        title:t('Type'),
        dataIndex:'notifyType',
        key:'notifyType',
        width:150,
        align:'center'
      },
      {
        title:t('Date'),
        key:'time',
        width:180,
        align:'center',
        render:(text,record)=>{
          return record.time?dayjs(record.time).format('YYYY-MM-DD HH:mm:ss'):''
        }
      },
      {
        title:t('Carrier Code'),
        dataIndex:'operator',
        key:'operator',
        width:180,
        align:'center'
      },
      {
        title:t('Operator'),
        dataIndex:'userName',
        key:'userName',
        width:250,
        align:'center'
      },
      {
        title:t('MarketingName'),
        dataIndex:'marketingName',
        key:'marketingName',
        width:250,
        align:'center'
      },
      {
        title:t('Notify By'),
        dataIndex:'notifyBy',
        key:'notifyBy',
        width:250,
        align:'center',
        render:(text,record)=>{
          return !record.notifyBy? 'API':'Manual'
        }
      },
      {
        title:t('Status'),
        key:'status',
        width:100,
        align:'center',
        render:(text,record)=>{
          return record.time?(record.status===0?t('Successful'):<Danger>{t('Failed')}</Danger>):''
        }
      },
      {
        title:t('Operation'),
        width:100,
        align:'center',
        key:'action',
        render:(text,record,index)=>(
          record.status?<a onClick={()=>{this.resend(record)}}>{t('Send Again')}</a>:''
        )
      }
    ]    
    return (
      <Container>
        <Filter filterChange={this.filterChange} search={this.search} download={this.download}></Filter>
        <Spin spinning={loading}>
          <RecordTable columns={columns} dataSource={recordList} rowKey="imei" pagination={pagination} onChange={this.handleTableChange} expandedRowRender={
            (record)=>(<RecordExpandTable imei={record.imei} startTime={filter.time[0]} endTime={filter.time[1]}></RecordExpandTable>)
          }></RecordTable>
        </Spin>
      </Container>
    )
  }
}

export default withTranslation()(SendRecord)